<template lang="pug">
  #Report
    appHeader(
      :hasBackTool="true"
    )
    router-view.content-body-hasFooter
    appSicFooter
</template>

<script>
import appHeader from '@/components/partials/AppHeader.vue';
import appSicFooter from '@/components/partials/AppSicFooter.vue';

export default {
  // 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'DistrictReportComponent',
  components: {
    appHeader,
    appSicFooter
  }
};
</script>
